module.exports = __webpack_public_path__ + "static/img/protect_1.09c0dd0b.png";